import _set from 'lodash/set'
import _get from 'lodash/get'
import React from 'react'
import { withFormik } from 'formik'

import Button from '../../_library/Button'
import Field from '../../_library/Field'

function validateAccess(data) {
  const errors = {}

  const access = _get(data, 'access')
  access.forEach((acc, index) => {
    if (!acc.firstName) {
      _set(errors, 'access[' + index + '].firstName', 'Required')
    }
    if (!acc.lastName) {
      _set(errors, 'access[' + index + '].lastName', 'Required')
    }
    if (!acc.email) {
      _set(errors, 'access[' + index + '].email', 'Required')
    }
    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    if (acc.email && !re.test(acc.email)) {
      _set(errors, 'access[' + index + '].email', 'Invalid Email')
    }
  })

  return errors
}

class DelegationManageAccessFormComponent extends React.Component {
  constructor(props) {
    super(props)
    this.addNewAccess = this.addNewAccess.bind(this)
  }

  addNewAccess() {
    this.props.setFieldValue('access', [
      ...this.props.values.access,
      {
        firstName: '',
        lastName: '',
        email: '',
        isNew: true,
      },
    ])
  }

  copyAccessLink(index) {
    const access = this.props.values.access[index]
    if (access && access.link) {
      navigator.clipboard.writeText(access.link)
        .then(() => {
          // Show success notification
          if (window.Messenger) {
            window.Messenger().post({
              type: 'success',
              message: 'Access link copied to clipboard, you can now share it with the person',
              hideAfter: 2,
              showCloseButton: true,
            })
          }
        })
        .catch(err => {
          console.error('Failed to copy link: ', err)
          if (window.Messenger) {
            window.Messenger().post({
              type: 'error',
              message: 'Failed to copy link to clipboard',
              hideAfter: 2,
              showCloseButton: true,
            })
          }
        })
    } else {
      // Show error notification if link is not available
      if (window.Messenger) {
        window.Messenger().post({
          type: 'error',
          message: 'Access link not available',
          hideAfter: 2,
          showCloseButton: true,
        })
      }
    }
  }

  removeAccess(index) {
    const access = [...this.props.values.access]
    access.splice(index, 1)
    this.props.setFieldValue('access', access)
  }

  render() {
    const {
      isSubmitting,
      handleSubmit,
      onCancel,
      values,
      touched,
      errors,
      handleChange,
      handleBlur,
      skippable,
    } = this.props

    return (
      <form ref="form" method="POST" onSubmit={handleSubmit}>
        {skippable && (
          <Button
            className="btn btn-success btn-shadow delegation-access-skip-btn"
            type="button"
            onClick={onCancel}
          >
            Skip for now
          </Button>
        )}
        <div className="delegation-access-container">
          {values.access.length > 0 && (
            <div className="delegation-access-header">
              <div className="delegation-access-col">First Name</div>
              <div className="delegation-access-col">Last Name</div>
              <div className="delegation-access-col">Email Address</div>
              <div className="delegation-access-col delegation-access-actions"></div>
            </div>
          )}
          
          {values.access.map((acc, index) => (
            <div className="delegation-access-row" key={index}>
              <div className="delegation-access-col">
                <div className="delegation-access-label">First Name</div>
                <div className="delegation-access-value">
                  {acc.isNew && (
                    <Field
                      type="text"
                      id={'access[' + index + '].firstName'}
                      value={values.access[index].firstName}
                      error={errors.access && errors.access[index] && errors.access[index].firstName}
                      touched={touched.access && touched.access[index] && touched.access[index].firstName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  )}
                  {!acc.isNew && <span>{acc.firstName}</span>}
                </div>
              </div>
              <div className="delegation-access-col">
                <div className="delegation-access-label">Last Name</div>
                <div className="delegation-access-value">
                  {acc.isNew && (
                    <Field
                      type="text"
                      id={'access[' + index + '].lastName'}
                      value={values.access[index].lastName}
                      error={errors.access && errors.access[index] && errors.access[index].lastName}
                      touched={touched.access && touched.access[index] && touched.access[index].lastName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  )}
                  {!acc.isNew && <span>{acc.lastName}</span>}
                </div>
              </div>
              <div className="delegation-access-col">
                <div className="delegation-access-label">Email Address</div>
                <div className="delegation-access-value">
                  {acc.isNew && (
                    <Field
                      type="text"
                      id={'access[' + index + '].email'}
                      value={values.access[index].email}
                      error={errors.access && errors.access[index] && errors.access[index].email}
                      touched={touched.access && touched.access[index] && touched.access[index].email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  )}
                  {!acc.isNew && <span>{acc.email}</span>}
                </div>
              </div>
              <div className="delegation-access-col delegation-access-actions">
                <div className="delegation-access-value">
                  <div className="btn-group mobile-btn-group">
                    <Button
                      className="btn btn-primary btn-shadow"
                      type="button"
                      title="Copy access link to clipboard"
                      onClick={this.copyAccessLink.bind(this, index)}
                    >
                      <i className="fa fa-copy" />
                    </Button>
                    <Button
                      className="btn btn-danger btn-shadow"
                      type="button"
                      onClick={this.removeAccess.bind(this, index)}
                    >
                      <i className="fa fa-trash" />
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          ))}
          
          {values.access.length === 0 && (
            <div className="delegation-access-empty text-center">
              No Persons Granted
            </div>
          )}
        </div>
        
        <div className="delegation-access-add-btn-container">
          <Button
            className="btn btn-primary btn-shadow delegation-access-add-access-btn"
            type="button"
            onClick={this.addNewAccess}
          >
            Add Person
          </Button>
        </div>
        
        <style jsx>{`
          .delegation-access-container {
            width: 100%;
            border: none;
            border-radius: 0.25rem;
            margin-bottom: 1.5rem;
            color: #fff;
            overflow: hidden;
          }
          .delegation-access-header {
            font-weight: bold;
            border-bottom: 2px solid rgba(120, 130, 140, 0.2);
            color: #fff;
            padding: 0.75rem 1rem;
            display: none;
          }
          .delegation-access-row {
            display: flex;
            flex-wrap: wrap;
            border-bottom: none;
          }
          .delegation-access-row:last-child {
            border-bottom: none;
          }
          .delegation-access-row:hover {
            background-color: rgba(255, 255, 255, 0.05);
          }
          .delegation-access-col {
            padding: 1rem;
            flex: 1 0 100%;
          }
          .delegation-access-label {
            font-weight: bold;
            margin-bottom: 0.5rem;
            color: rgba(255, 255, 255, 0.7);
          }
          .delegation-access-value {
            color: #fff;
          }
          .delegation-access-empty {
            padding: 1.25rem;
            color: rgba(255, 255, 255, 0.7);
            text-align: center;
            font-style: italic;
          }
          .delegation-access-actions {
            display: flex;
            justify-content: flex-end;
            align-items: center;
          }
          .mobile-btn-group {
            width: 100%;
            display: flex;
            gap: 10px;
          }
          .mobile-btn-group .btn {
            flex: 1;
            min-width: 40px;
            overflow: visible;
            white-space: nowrap;
          }
          .delegation-access-add-access-btn {
            margin-bottom: 1rem;
          }
          .delegation-access-skip-btn {
            margin-left: 0.5rem;
            margin-bottom: 1rem;
          }
          
          .delegation-access-add-btn-container {
            display: flex;
            justify-content: center;
            margin-bottom: 1.5rem;
          }
          
          @media (min-width: 768px) {
            .delegation-access-header {
              display: flex;
            }
            .delegation-access-row {
              display: flex;
              flex-wrap: nowrap;
            }
            .delegation-access-col {
              flex: 1;
              display: flex;
              align-items: center;
            }
            .delegation-access-value {
              width: 100%;
            }
            .delegation-access-label {
              display: none;
            }
            .delegation-access-col:not(:last-child) {
              border-right: none;
            }
            .delegation-access-actions {
              flex: 0 0 auto;
              width: 130px;
              padding-right: 1.25rem;
            }
            .mobile-btn-group {
              width: auto;
              justify-content: flex-end;
            }
            .mobile-btn-group .btn {
              flex: none;
            }
          }
          
          @media (max-width: 767px) {
            .delegation-access-actions {
              padding-bottom: 1.25rem;
            }
          }
        `}</style>
        <div className="btn-toolbar btn-toolbar-right text-right">
          <Button className="btn btn-primary btn-shadow" type="submit" loading={isSubmitting}>
            Save Permissions
          </Button>
          <Button
            className="btn btn-danger btn-shadow"
            type="button"
            onClick={onCancel}
            disabled={isSubmitting}
          >
            Cancel
          </Button>
        </div>
      </form>
    )
  }
}

const DelegationManageAccessForm = withFormik({
  mapPropsToValues: props => ({
    access: _get(props, 'initialValues.attributes.access') || [],
  }),

  // Custom sync validation
  validate: values => validateAccess(values),

  handleSubmit: (values, { props, setSubmitting }) => {
    props
      .onSubmit({
        attributes: { ...values },
      })
      .then(v => {
        setSubmitting(false)
      })
      .catch(err => {
        setSubmitting(false)
      })
  },
  displayName: 'DelegationManageAccessForm', // helps with React DevTools
})(DelegationManageAccessFormComponent)

export default DelegationManageAccessForm
